module.exports = __webpack_public_path__ + "ad6714cec4d7d061674b48d19cc1bf9c.pdf";